import { render, staticRenderFns } from "./craetePack.vue?vue&type=template&id=4c687a69"
import script from "./craetePack.vue?vue&type=script&lang=js"
export * from "./craetePack.vue?vue&type=script&lang=js"
import style0 from "./craetePack.vue?vue&type=style&index=0&id=4c687a69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports